const finalSaleCategoryId = import.meta.env.VITE_FINAL_SALE_CATEGORY_ID;
const normalizedFinalSaleCategoryId =
  typeof finalSaleCategoryId === "string"
    ? finalSaleCategoryId
    : typeof finalSaleCategoryId === "number" &&
      Number.isFinite(finalSaleCategoryId)
    ? String(finalSaleCategoryId)
    : null;

/**
 * The Final Sale category is deployment configuration. An absent or malformed
 * value must leave Final Sale identity unresolved rather than selecting a
 * different category.
 */
export const FINAL_SALE_CATEGORY_ID =
  normalizedFinalSaleCategoryId !== null &&
  /^[1-9]\d*$/.test(normalizedFinalSaleCategoryId)
    ? normalizedFinalSaleCategoryId
    : null;
